module.exports = __webpack_public_path__ + "img/avatar_temp.98293eba.png";